import { DatePicker } from "@mui/x-date-pickers";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
const UseInfoBirthday = ({ userInfo, setUserInfo, validateStatus, setValidateStatus }) => {
  const today = dayjs();
  const minDate = today.subtract(100, "year"); // 100歳
  const maxDate = today.subtract(3, "year");   // 3歳
  const birthdayHandler = (date) => {
    const inputDate = dayjs(date);
    let val = { valid: true, message: '' };
    if (inputDate.isBefore(minDate) || inputDate.isAfter(maxDate)) {
      val = {
        valid: false,
        message: '年齢は3歳〜100歳の範囲で入力してください',
      };
    }

    setValidateStatus(prev => ({
      ...prev,
      birthday: val
    }));

    setUserInfo(prev => ({
      ...prev,
      birthday: inputDate.format('YYYY/MM/DD')
    }));
  };

  return <>
    <dt>誕生日 <span>※</span></dt>
    <dd>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          label="生年月日"
          format="YYYY/MM/DD"
          error={!validateStatus.birthday.valid}
          minDate={minDate}
          maxDate={maxDate}
          value={userInfo.birthday ? dayjs(userInfo.birthday) : null}
          onChange={birthdayHandler}
          sx={{ width: "100%" }}
          slotProps={{
            textField: {
              error: userInfo.birthday === null ? false : undefined,
              helperText: userInfo.birthday === null ? '' : undefined,
            },
          }}
        />
      </LocalizationProvider>
      {validateStatus.birthday.message !== '' &&
        <span className="error" >{validateStatus.birthday.message}</span>
      }
    </dd>
  </>
}
export default UseInfoBirthday;
